export class GradingSystem {
    static GRADE_SCORE = "Grade - Score";
    static SCORE_ALLOCATION = "Score Allocation";
    static EXTRAS = "Behaviours";

    type: GradingSystemTypeValue;

    constructor(type: GradingSystemTypeValue) {
        this.type = type;
    }
}

export type GradingSystemTypeValue =
    | "Grade - Score"
    | "Score Allocation"
    | "Behaviours";
